import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { isDefined } from "@vueuse/core";
import { login, getInfo, logout } from "@/api/user";
import { getConfig } from "@/utils";
import AES from "@/utils/aes";

export const useUserInfoStore = defineStore(
  "userInfoConfig",
  () => {
    // 语言
    const language = ref("zh_CN");
    // const language = ref(navigator.language === "zh-CN" ? "zh_CN" : "en_US");

    const setLanguage = (lang: string) => {
      language.value = lang;
    };

    // 用户信息
    const userInfo = ref({});
    // token
    const token = ref("");
    // 用户id
    const userId = ref(0);
    // 用户是否登录
    const isLogin = computed(() => {
      return Boolean(token.value && userId.value);
    });
    // 用户不是通过链接登录 默认不是
    const noLinkLogin = ref(1);
    // 设置用户信息配置
    function setData(params: {
      userInfo?: any;
      token?: string;
      userId?: number;
      noLinkLogin?: number;
    }) {
      userInfo.value = isDefined(params.userInfo)
        ? params.userInfo
        : userInfo.value;
      token.value = isDefined(params.token) ? params.token : token.value;
      userId.value = isDefined(params.userId) ? params.userId : userId.value;
      noLinkLogin.value = isDefined(params.noLinkLogin)
        ? params.noLinkLogin
        : noLinkLogin.value;
    }
    // 重置用户信息配置
    function $resetUserInfo() {
      userInfo.value = {};
      token.value = "";
      userId.value = 0;
      noLinkLogin.value = 1;
      language.value = "en_US";
    }

    /** 登录方法 */
    function loginFn(formData: any) {
      return new Promise((resolve, reject) => {
        const password = AES.encrypt(
          formData.password,
          getConfig("pwd_secret_key")
        );

        const params = new FormData();
        params.append("deviceType", "0");
        params.append("email", formData.email);
        params.append("password", password);
        login(params)
          .then((res: any) => {
            if (res.success) {
              const resultData = res.resultMap;
              setData({
                token: resultData.token,
                userId: resultData.userId,
              });
              resolve(res);
              // 获取详细信息
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
          });
      });
    }
    /** 获取用户信息方法 */
    function getUserInfoFn() {
      return new Promise((resolve, reject) => {
        getInfo({ userId: userId.value })
          .then(({ success, resultMap }: any) => {
            if (success) {
              setData({
                userInfo: resultMap,
              });
              resolve({ success, resultMap });
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
          });
      });
    }
    /** 登出逻辑 */
    function logoutFn() {
      logout({ userId: userId.value });
      setTimeout($resetUserInfo);
    }

    return {
      language,
      setLanguage,
      userInfo,
      token,
      userId,
      noLinkLogin,
      isLogin,
      setData,
      $resetUserInfo,
      loginFn,
      getUserInfoFn,
      logoutFn,
    };
  },
  {
    // 所有数据持久化
    // persist: true,
    // 持久化存储插件其他配置
    persist: {
      // 修改存储中使用的键名称，默认为当前 Store的 id
      key: "ltw-userInfoConfig",
      // 修改为 sessionStorage，默认为 localStorage
      storage: localStorage,
    },
  }
);
